import React from 'react';
import {Navigate, useOutletContext} from 'react-router-dom';
import {formatCredits} from '../../../utils/credits';
import {formatDate} from '../../../utils/dates';
import Membership from '../forms/Membership';
import SettingsPanel from './SettingsPanel';

export const MembershipSummary = ({ membership }) => (
    <div className="me-3 text-center">
        <span
            className={`fas me-2 ${membership?.active ? 'text-success fa-toggle-on' : 'text-danger fa-toggle-off'}`}/>
        <span className="text-uppercase">
            {membership?.active ? 'Active' : 'Inactive'}
        </span>

        <span className="ms-3 border-start border-primary ps-3" />
        <span className="fas fa-calendar me-2 text-primary" />
        <span>
            Commissioning Date: {membership?.commissioningDate
            ? formatDate(membership.commissioningDate)
            : 'Unknown'}
        </span>

        <span className="ms-3 border-start border-primary ps-3" />
        <span className="fas fa-list-numeric me-2 text-primary" />
        <span>
            Renewal date: {membership?.renewalDate
            ? formatDate(membership.renewalDate)
            : 'Unknown' }
        </span>

        <span className="ms-3 border-start border-primary ps-3" />
        <span className="fas fa-coins me-2 text-primary" />
        <span>
            Annual membership fee: {membership?.annualMembershipCost
            ? `${formatCredits(membership.annualMembershipCost)} credits`
            : 'Not set'}
        </span>
    </div>
);

const MembershipTab = () => {
    const { organization, bacView, handleUpdate } = useOutletContext();

    if (!bacView) {
        return <Navigate to="../overview" replace />;
    }

    return (
        <SettingsPanel
            icon="fa-book-open"
            title="Membership"
            defaultOpen
            summary={<MembershipSummary membership={organization.membership} />}
        >
            <Membership
                initialSettings={organization.membership}
                onSave={handleUpdate('membership')}
            />
        </SettingsPanel>
    );
};

export default MembershipTab;
